import colors from '../../colors';

export default function(state) {
  if (typeof state === 'undefined') {
    return colors;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/color/index.js